import React from 'react';
import { useController } from 'react-hook-form';
import { ButtonGroup } from 'ui/buttonGroup';
import { ButtonGroupProps } from 'ui/buttonGroup/ButtonGroup';
import { FieldProps } from './types';

export type ButtonGroupFieldProps = FieldProps &
  Omit<
    ButtonGroupProps,
    'children' | 'id' | 'onChange' | 'defaultSelectedId' | 'defaultSelectedIds'
  > & {
    id?: string;
    children: React.ReactNode;
  };

export const ButtonGroupField = ({ name, id, children, ...rest }: ButtonGroupFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
  });

  return (
    <ButtonGroup id={id || name} onSelect={onChange} defaultSelectedIds={value} {...rest}>
      {children}
    </ButtonGroup>
  );
};
